import { Link } from "react-router-dom";
import { MapPin, Clock, Users, BadgeCheck, CalendarClock } from "lucide-react";
import { inr } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const fmtColor = {
  Offline: "bg-amber-100 text-amber-800 dark:bg-amber-950/50 dark:text-amber-300",
  Hybrid: "bg-orange-100 text-orange-800 dark:bg-orange-950/50 dark:text-orange-300",
  Online: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-300",
};

export function CourseCard({ course }) {
  return (
    <Link
      to={`/courses/${course.id}`}
      data-testid={`course-card-${course.id}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-lg"
    >
      <div className="relative h-40 overflow-hidden">
        <img src={course.image_url} alt={course.title}
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
        <span className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-semibold ${fmtColor[course.format] || fmtColor.Offline}`}>
          {course.format}
        </span>
        <span className="absolute right-3 top-3 rounded-full bg-black/70 px-2.5 py-1 text-xs font-semibold text-white font-mono-nums">
          {inr(course.fee)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <div className="mb-1 flex items-center gap-1 text-xs font-semibold uppercase tracking-wider text-accent">
          {course.specialty}
        </div>
        <h3 className="font-heading text-lg font-bold leading-snug text-foreground group-hover:text-primary">
          {course.title}
        </h3>
        {course.institute && (
          <div className="mt-1 flex items-center gap-1 text-sm text-muted-foreground">
            {course.institute.name}
            {course.institute.verified && <BadgeCheck className="h-4 w-4 text-primary" />}
          </div>
        )}
        <div className="mt-3 flex flex-wrap gap-1.5">
          {(course.eligibility || []).slice(0, 3).map((e) => (
            <Badge key={e} variant="secondary" className="text-[11px]">{e}</Badge>
          ))}
        </div>
        <div className="mt-4 grid grid-cols-2 gap-2 border-t border-border pt-4 text-xs text-muted-foreground">
          <span className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" /> {course.city}</span>
          <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" /> {course.duration}</span>
          <span className="flex items-center gap-1.5"><Users className="h-3.5 w-3.5" /> {course.seats} seats</span>
          {course.application_deadline && (
            <span className="flex items-center gap-1.5"><CalendarClock className="h-3.5 w-3.5" /> {course.application_deadline}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
